module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Sensors have not detected any data.","subtitle":"Wait until the sensors have processed at least one data acquisition. Refresh the page and try again."},"it":{"title":"Al momento, i sensori non hanno ancora rilevato nessun dato.","subtitle":"Attendi fino a quando i sensori non avranno effettuato almeno un’acquisizione. Aggiorna la pagina e riprova."}}')
  delete Component.options._Ctor
}
